/**
 * Simplifies combining class names.
 *
 * @example
 * classNames(
 *   'here are some default class names',
 *   onlyWhenThisIsTruthy && 'yep it is truthy',
 *   maybeUseTernaries ? 'yep' : 'nope
 * );
 * @param classes
 */
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(" ");
}

export { classNames };
//# sourceMappingURL=classNames.esm.js.map
